import httpClient from 'api/core/httpClient';
import auth from 'api/core/auth';

class BaseApi {
  constructor(resource) {
    this.httpClient = httpClient;
    this.resource = resource;
  }

  getResourceUrl() {
    const companyDomain = auth.getCompanyDomain();

    return `${companyDomain}/${this.resource}/`;
  }

  getList(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString
      ? `${this.getResourceUrl()}?${queryString}`
      : this.getResourceUrl();

    return this.httpClient.get(url);
  }

  getById(id) {
    return this.httpClient.get(`${this.getResourceUrl()}${id}/`);
  }

  create(data) {
    return this.httpClient.post(this.getResourceUrl(), data);
  }

  createForm(formData, customUrl = '') {
    const url = customUrl
      ? `${this.getResourceUrl()}${customUrl}`
      : this.getResourceUrl();

    return this.httpClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  update(id, data) {
    return this.httpClient.put(`${this.getResourceUrl()}${id}/`, data);
  }

  patch(id, data) {
    return this.httpClient.patch(`${this.getResourceUrl()}${id}/`, data);
  }

  patchForm(id, formData) {
    return this.httpClient.patch(`${this.getResourceUrl()}${id}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  delete(id) {
    return this.httpClient.delete(`${this.getResourceUrl()}${id}/`);
  }
}

export default BaseApi;
